var React = require('react');

function ArrowRightWhiteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 1.86859L1.39309 0.498047L8 6.99805L1.39309 13.498L0 12.1275L5.21383 6.99805L0 1.86859Z","fill":"#ffffff"}));
}

ArrowRightWhiteInline.defaultProps = {"width":"8","height":"14","viewBox":"0 0 8 14","fill":"none"};

module.exports = ArrowRightWhiteInline;

ArrowRightWhiteInline.default = ArrowRightWhiteInline;
